// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1nh1B","content":"styles_content___3IOy"};